import { shallowMount } from "@vue/test-utils";
import ProvinceList from "@/components/core/composite/combos/ProvinceList";

describe("ProvinceList component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(ProvinceList);
  });

  it("Renders del component ProvinceList", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
